import { MTixCover } from "@components/pages/mtix/mtix-cover"
import { MTixSlider } from "@components/pages/mtix/mtix-slider"
import { MtixTopup } from "@components/pages/mtix/mtix-topup"
import { getPageBySlug } from "lib/api"
import { metaDesc } from "src/helper/meta-desc"
import { extractMeta } from "src/mixins"

export default function MTixPage({ data, locale }) {
  const pageData = data?.meta
  const cover = extractMeta(pageData, "hero")
  const slider = extractMeta(pageData, "download_section")
  const topup = extractMeta(pageData, "top_up")
  const topupPartners = extractMeta(pageData, "top_up_partners")
  const paymentPartners = extractMeta(pageData, "payment_partners")
  return (
    <>
      <MTixCover data={cover} locale={locale} />
      <MTixSlider data={slider} locale={locale} />
      <MtixTopup
        data={{ topup, paymentPartners, topupPartners }}
        locale={locale}
      />
    </>
  )
}

export async function getStaticProps(ctx) {
  const { locale } = ctx
  const data = await getPageBySlug("m-tix")
  return {
    props: {
      seo: {
        title: (data && data[`title_${locale}`]) || "m.tix",
        description: metaDesc[`mtix_${locale}`],
      },
      page: "m-tix",
      data,
      locale,
    },
    revalidate: 60,
  }
}
